import { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmarkCircle } from '@fortawesome/pro-light-svg-icons'
import { Chip, Grid, Typography } from '@mui/material';

import { useFetchBulletinsQuery } from '../../../redux/bulletinApi';

interface SideBarProps {
    onTagSelect: (tags: string[]) => void;
}

export const SideBar: React.FC<SideBarProps> = ({ onTagSelect }) => {
    const { data } = useFetchBulletinsQuery();
    const [tags, setTags] = useState<string[]>([]);
    const [selectedTags, setSelectedTags] = useState<string[]>([]); // Use an array to store selected tags

    useEffect(() => {
        if (data) {
            // Extract tags from the API data, remove duplicates, convert to lowercase, and sort alphabetically
            const uniqueSortedTags = Array.from(new Set(data.flatMap((article) => article.tags)))
                .map(tag => tag.toLowerCase())
                .sort()
                .map(tag => {
                    // Find the original casing of the tag
                    const originalTag = data.find(article => article.tags.map(t => t.toLowerCase()).includes(tag))?.tags.find(t => t.toLowerCase() === tag);
                    return originalTag || tag; // Use lowercase tag if original casing is not found
                });
            setTags(uniqueSortedTags);
        }
    }, [data]);

    // Function to handle tag selection/deselection
    const handleFilterButtonClick = (tag: string) => {
        const isSelected = selectedTags.includes(tag);
        let updatedTags: string[];

        if (isSelected) {
            updatedTags = selectedTags.filter((selectedTag) => selectedTag !== tag);
        } else {
            updatedTags = [...selectedTags, tag];
        }

        setSelectedTags(updatedTags);
        onTagSelect(updatedTags);
    };

    return (
        <>
            <Typography variant="h1" fontWeight={100} sx={{ p: 2, mt: 2 }}>
                Tags
            </Typography>
            <Grid container spacing={1} sx={{ p: 2, pt: 0 }}>
                {tags.map((tag, id) => (
                    <Grid item key={id}>
                        <Chip
                            label={tag}
                            key={`tags-${id}`}
                            onClick={() => handleFilterButtonClick(tag)}
                            sx={{
                                backgroundColor: selectedTags.includes(tag) ? '#00AD99' : 'default',
                                color: selectedTags.includes(tag) ? '#ffffff' : 'default',
                            }}
                            deleteIcon={<FontAwesomeIcon icon={faXmarkCircle} size="xl" style={{
                                fontSize: '1.3rem',
                                display: selectedTags.includes(tag) ? 'block' : 'none',
                                color: '#ffffff',
                            }}/>}
                            onDelete={() => {
                                const updatedTags = selectedTags.filter(
                                    (selectedTag) => selectedTag !== tag
                                );
                                setSelectedTags(updatedTags);
                                onTagSelect(updatedTags);
                            }}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};